export enum MenuItemsLayout {
  ListMenu = 'List Menu',
  /**@deprecated. Table layout is no longer supported.*/
  TableMenu = 'Table Menu',
  CardMenu = 'Card Menu',
  FlatMenu = 'Flat Menu',
  SlidingCardMenu = 'Sliding Card Menu',
}
